<template>
  <div @click="unClick">
    <div
      id="files-view"
      class="files-view-action"
      @contextmenu.prevent.capture="contextMenu($event, undefined)"
    >
      <div id="file-content-id" class="file-content" tabindex="-1">
        <div ref="fileContainer" class="files-container">
          <!--Item previews list-->
          <div v-if="isList" class="file-list-wrapper">
            <transition-group
              name="file"
              tag="section"
              class="file-list"
              :class="FilePreviewType"
            >
              <FileItemList
                v-for="item in files"
                :key="item.unique_id"
                :item="item"
                class="file-item"
              ></FileItemList>
            </transition-group>
          </div>

          <!--Item previews grid-->
          <div v-if="isGrid" class="file-grid-wrapper">
            <transition-group
              name="file"
              tag="section"
              class="file-list"
              :class="FilePreviewType"
            >
              <FileItemGrid
                v-for="item in files"
                :key="item.unique_id"
                :item="item"
                class="file-item"
                :show-file-name="showFileName"
                :show-file-size="showFileSize"
                :show-file-extension="showFileExtension"
              ></FileItemGrid>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileItemList from '@assets/js/components/FileItemList'
import FileItemGrid from '@assets/js/components/Preview/FileItemGridPreview'
import { mapGetters } from 'vuex'
import { events } from '@main/js/bus'

export default {
  name: 'FilesView',
  components: {
    FileItemList,
    FileItemGrid,
  },
  props: {
    folder: {
      type: [Number, String],
      default: null,
    },
    showFileName: {
      type: [Boolean, Number, String],
      default: 0,
    },
    showFileSize: {
      type: [Boolean, Number, String],
      default: 0,
    },
    showFileExtension: {
      type: [Boolean, Number, String],
      default: 0,
    },
  },
  data() {
    return {
      files: null,
      FilePreviewType: 'grid',
      isLoading: false,
      mobileMultiSelect: false,
    }
  },
  computed: {
    ...mapGetters(['config']),
    isGrid() {
      return this.FilePreviewType === 'grid'
    },
    isList() {
      return this.FilePreviewType === 'list'
    },
    isEmpty() {
      return this.files.length == 0
    },
  },
  mounted() {
    this.$checkOS()
    this.getFiles()
  },
  methods: {
    contextMenu(event, item) {
      events.$emit('contextMenu:show', event, item)
    },
    unClick() {
      events.$emit('unClick')
    },
    async getFiles(e) {
      if (this.folder) {
        await this.$store
          .dispatch('getFolderById', {
            folder_uid: this.folder,
          })
          .then((res) => {
            this.files = res.data
            // Make files available for full preview navigation
            this.$store.commit('LOADING_STATE_PREVIEW', {
              loading: false,
              dataPreview: res.data,
            })
          })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.empty-page {
  padding: 0 10px;
  .empty-state {
    .text-content {
      height: 100%;
      min-height: 100px;
      width: 100%;
      background: $light_background;
      border-radius: 3px;
      .file-input {
        height: 100%;
        min-height: 100px;
        width: 100%;
        margin-bottom: 0;
        text-align: center;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}

.file-list {
  .dragged {
    :deep(.is-dragenter) {
      border: 2px solid transparent;
    }
  }
}

.file-item-upload {
  text-align: center;
  .file-item {
    .file-icon-upload {
      margin-bottom: 13px;
    }
    .item-name {
      color: $text;
      @include font-size(13);
      font-weight: 600;
      max-height: 40px;
      line-height: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
    &:hover {
      cursor: pointer;
    }
  }
  &:hover {
    cursor: pointer;
    border-radius: 8px;
    background: $light_background;
  }
}

/*.file-item-upload {
    .file-item {
      .item-name {
        padding-left: 22px;
        padding-right: 22px;
        text-align: center;
        .name {
          @include font-size(14);
          color: #1b2539;
          font-weight: 600;
          max-height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          line-height: 14px;
        }
      }
    }
  }*/

.icon-item {
  text-align: center;
  position: relative;
  height: 115px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  .file-link {
    display: block;
  }

  .file-icon {
    @include font-size(100);
    margin: 0 auto;

    path {
      fill: #fafafc;
      stroke: #dfe0e8;
      stroke-width: 1;
    }
  }

  &.file-icon-upload {
    .file-icon {
      @include font-size(60);
      margin: 20px auto 0 auto;
      path {
        fill: $color-secondary;
        stroke: $color-secondary;
        stroke-width: 1;
      }
    }
  }

  &.file-icon-on-empty {
    margin-top: 7px;
    margin-bottom: 0;
    height: 60px;
    .file-icon {
      @include font-size(50);
      margin: 0 auto;
      path {
        fill: $color-secondary;
        stroke: $color-secondary;
        stroke-width: 1;
      }
    }
  }
}

.file-content {
  display: flex;
  min-height: 100px;
}

.files-container {
  overflow-x: hidden;
  overflow-y: auto;
  flex: 0 0 100%;
  @include transition(150ms);
  position: relative;
  scroll-behavior: smooth;

  &.is-fileinfo-visible {
    flex: 0 1 100%;
  }

  .file-list {
    &.grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, 150px);
      justify-content: space-evenly;
    }
  }
}

.file-info-container {
  flex: 0 0 300px;
  padding-left: 20px;
  overflow: auto;
}

// Transition
.file-move {
  transition: transform 0.6s;
}

.file-enter-active {
  transition: all 300ms ease;
}

.file-leave-active {
  transition: all 0ms;
}

.file-enter, .file-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-20px);
}

@media only screen and (min-width: 960px) {
  /*  .file-content {
      position: absolute;
      top: 0;
      left: 15px;
      right: 15px;
      bottom: 0;
      @include transition;
      overflow-y: auto;
      overflow-x: hidden;

      &.is-offset {
        margin-top: 50px;
      }
    }*/
}

@media only screen and (max-width: 960px) {
  .file-info-container {
    display: none;
  }

  .mobile-search {
    display: block;
  }
  .file-content {
    position: relative;
    top: 0px;
    left: 15px;
    right: 15px;
    bottom: 0;
    @include transition;
    overflow-y: auto;
    overflow-x: hidden;

    &.is-offset {
      margin-top: 50px;
    }
  }
}

@media only screen and (max-width: 690px) {
  .files-container {
    padding-left: 0;
    padding-right: 0;
    /*    top: 0;
      left: 0;
      right: 0;
      bottom: 0;*/
    /* position: fixed;
      overflow-y: auto;*/

    .file-list {
      &.grid {
        grid-template-columns: repeat(auto-fill, 120px);
      }
    }
  }

  /*
    .file-content {
      position: absolute;
      top: 0;
      left: 0px;
      right: 0px;
      bottom: 0;
      @include transition;

      &.is-offset {
        margin-top: 50px;
      }
    }
  */

  .mobile-search {
    margin-bottom: 0;
  }

  .file-info-container {
    display: none;
  }
}
</style>
